<template>
  <div ref="trendChart1" id="trend-chart1"></div>
</template>

<script>
import echarts from 'echarts'
import { yDataFormat1 } from '@/utils/yDataFormat'

const chartTheme = require('@/styles/chart_theme/macarons.json')

const legend = [
  'Clicks',
  'New Registrations',
  'New Real Traders',
  'Qualified Real Traders',
  'CPA Bonus',
]
let chart = undefined

export default {
  name: 'LineChart',
  props: {
    YMDDateList: {
      type: Array,
      require: true,
    },
    xData: {
      type: Array,
      require: true,
    },
    chartData: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      series: {},
    }
  },
  watch: {
    chartData() {
      this.series = yDataFormat1(this.chartData, legend, this.YMDDateList)
      this.initChart()
    },
  },
  methods: {
    initChart() {
      echarts.registerTheme('macarons', chartTheme)
      chart = echarts.init(this.$refs.trendChart1, 'macarons')
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            snap: true,
          },
        },
        legend: {
          data: legend,
          type: 'scroll',
        },
        xAxis: {
          type: 'category',
          data: this.xData,
        },
        yAxis: [
          {
            name: 'CPA Bonus',
            type: 'value',
            minInterval: 1,
          },
          {
            name: 'Others',
            type: 'value',
            minInterval: 1,
          },
        ],
        series: this.series,
      })
    },
  },
}
</script>

<style>
#trend-chart1 {
  margin-top: 20px;
  width: 100%;
  height: 300px;
}
</style>
